import { apiClient, ApiName } from '@shared/services/api'

export const fetchAndProcessMasks = () => {
  return apiClient.get(ApiName.ADMINS, 'super/spreads/default')
}

export const fetchVariation = () => {
  return apiClient.get(ApiName.ADMINS, 'super/variations')
}
